import darken from 'polished/lib/color/darken'
import queryString from 'query-string'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import LogoAutenticacao from '../../../images/icons/gov/LogoAutenticacao'
import { useSelectedLanguage } from '../../../translations/utils'

const {REACT_APP_BASE_URL, REACT_APP_ENDPOINT_LOGIN} = process.env

const govColor = '#1D70B7'

const LoginButton = styled.button`
  background-color: ${govColor};
  border-radius: 16px;
  padding: 0.5em 1em;
  appearance: none;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  & > svg {
    height: 3.5em;
    display: block;
  }

  &:hover {
    background-color: ${darken(0.1, govColor)};
  }

  &:active {
    background-color: ${darken(0.2, govColor)};
  }
`

function getAuthorisationUrl(language: string): string {
  const oAuthUrl = REACT_APP_ENDPOINT_LOGIN

  const params = {
    backTo: `${REACT_APP_BASE_URL}/${language}/status`
  }

  return `${oAuthUrl}?${queryString.stringify(params, {encode: false})}`
}

export default function LoginButtonGov() {
  const selectedLanguage = useSelectedLanguage()
  const intl = useIntl()

  const goToAuth = () => {
    const authorisationUrl = getAuthorisationUrl(selectedLanguage)
    window.location.href = authorisationUrl
  }

  return (
    <LoginButton onClick={goToAuth} title={intl.formatMessage({id: 'login.gov.buttonTitle'})}>
      <LogoAutenticacao background="dark" />
    </LoginButton>
  )
}
